import { render, staticRenderFns } from "./StatsEstablishment.vue?vue&type=template&id=5b59cc03"
import script from "./StatsEstablishment.vue?vue&type=script&lang=js"
export * from "./StatsEstablishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports